import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const deleteRecordingComment = async ({
  orgId,
  recordingId,
  commentId,
}: {
  orgId: string;
  recordingId: string;
  commentId: string;
}): Promise<void> => {
  const response = await axiosClient.delete(
    `${orgId}/recordings/${recordingId}/comments/${commentId}`,
  );
  return response.data;
};

export function useDeleteRecordingComment(
  queryOptions?: UseMutationOptions<
    void,
    HttpError,
    { orgId: string; recordingId: string; commentId: string }
  >,
) {
  return useMutation({
    mutationFn: ({ orgId, recordingId, commentId }) =>
      deleteRecordingComment({ orgId, recordingId, commentId }),
    ...queryOptions,
  });
}
